import { apiDelete, apiGet, apiPost, apiPut, queryString, type ApiResult } from "./client";
import type { AffectedLessons, Teacher, TeacherWeek, UnavailabilityReason, WeeklyUnavailable } from "./types";
import type { CellRange } from "../time";

export interface TeacherFields {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  telegram: string;
  note: string;
  courseIds: string[];
  weeklyUnavailable: WeeklyUnavailable[];
}

export interface NewPeriod {
  dateFrom: string;
  dateTo: string;
  range: CellRange | null;
  reason: UnavailabilityReason;
  note: string;
}

export async function fetchTeachers(includeArchived: boolean): Promise<ApiResult<Teacher[]>> {
  return apiGet<Teacher[]>("/teachers" + queryString({ includeArchived }));
}

export async function fetchTeacher(id: string): Promise<ApiResult<Teacher>> {
  return apiGet<Teacher>(`/teachers/${id}`);
}

export async function createTeacher(fields: TeacherFields): Promise<ApiResult<Teacher>> {
  return apiPost<Teacher>("/teachers", fields);
}

export async function updateTeacher(id: string, fields: TeacherFields, version: number): Promise<ApiResult<Teacher>> {
  return apiPut<Teacher>(`/teachers/${id}`, { ...fields, version });
}

export async function setTeacherArchived(id: string, archived: boolean,
  version: number): Promise<ApiResult<Teacher>> {
  const action: string = archived ? "archive" : "unarchive";
  return apiPost<Teacher>(`/teachers/${id}/${action}`, { version });
}

export async function deleteTeacher(id: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/teachers/${id}`);
}

export async function addTeacherPeriod(id: string, period: NewPeriod): Promise<ApiResult<AffectedLessons>> {
  return apiPost<AffectedLessons>(`/teachers/${id}/unavailability`, period);
}

export async function removeTeacherPeriod(id: string, periodId: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/teachers/${id}/unavailability/${periodId}`);
}

export async function fetchTeacherWeek(id: string, from: string): Promise<ApiResult<TeacherWeek>> {
  return apiGet<TeacherWeek>(`/teachers/${id}/week` + queryString({ from }));
}
